export class GUID {
    static create(): string {
        let guid = '';
        for (let i = 0; i < 4; i++) {
            guid += Math.ceil(Math.random() * 0xFFFFFFFF).toString(16);
        }
        return guid;
    }
}
